export const MATTERPORT_URL_WITHOUT_ID = 'https://my.matterport.com/show/?m=';
